<template>
  <div class="slider-container">
    <input
      v-model.number="currentValue"
      type="range"
      :min="min"
      :max="max"
      :step="interval"
      class="slider"
      @mouseenter="showTooltip"
      @mouseleave="hideTooltip"
    />

    <transition>
      <div v-if="tooltipVisible" class="tooltip" :style="tooltipStyle">
        {{ currentValue }}
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
// import { watchThrottled } from '@vueuse/core';
import { ref, computed, watch } from 'vue';

const emit = defineEmits(['update:modelValue']);

const props = defineProps({
  modelValue: {
    type: Number,
    default: 50,
  },
  min: {
    type: Number,
    default: 0,
  },
  max: {
    type: Number,
    default: 100,
  },
  interval: {
    type: Number,
    default: 1,
  },
  tooltip: {
    type: Boolean,
    default: false,
  },
  debounce: {
    type: Number,
    default: 0,
  },
});

const currentValue = ref(props.modelValue);
const tooltipVisible = ref(false);

const tooltipStyle = computed(() => ({
  left: `calc(${((currentValue.value - props.min) / (props.max - props.min)) * 100}% + 8px - (16px * ${
    (currentValue.value - props.min) / (props.max - props.min)
  })`,
}));

// watchThrottled(
//   currentValue,
//   (value) => {
//     emit('update:value', value);
//   },
//   { throttle: () => props.debounce }
// );
watch(currentValue, (value) => {
  emit('update:modelValue', value);
});

const showTooltip = () => {
  if (props.tooltip) {
    tooltipVisible.value = true;
  }
};

const hideTooltip = () => {
  tooltipVisible.value = false;
};
</script>

<style scoped>
.slider-container {
  position: relative;
}

.slider {
  @apply w-full bg-gray-300 h-1.5 rounded-full cursor-pointer appearance-none;
  outline: none;
}

.slider::-webkit-slider-thumb {
  @apply w-4 h-4 bg-blue-500 rounded-full shadow appearance-none cursor-pointer;
  -webkit-appearance: none;
}

.slider::-moz-range-thumb {
  @apply w-4 h-4 bg-blue-500 rounded-full shadow cursor-pointer;
}

.tooltip {
  position: absolute;
  bottom: 110%;
  transform: translateX(-50%);
  @apply p-2 text-xs rounded bg-gray-800 text-white;
}
</style>
